import { render, staticRenderFns } from "./FarmTableBody.vue?vue&type=template&id=0e979021&"
import script from "./FarmTableBody.vue?vue&type=script&lang=ts&"
export * from "./FarmTableBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports